import {useCmsNavItemsStore} from "@/store/cmsNavItems"
import {useSlideOverStore} from "@/store/slideOver"

type HeaderMenuItem = {
    title?: string;
    titleRaw?: string | (() => string);
    path?: string | Object ;
    isCmsPath?: boolean;
    function?: () => void;
    icon?: string;
    color?: string;
    initial?: string;
    ability?: string[];
    children?: HeaderMenuItem[];
    showUnauthenticated: boolean;
    showAuthenticated: boolean;
}

type HeaderMenu = HeaderMenuItem[];

export const getHeaderMenu = (useCmsNavItems:boolean = false): HeaderMenu => {
    const cmsNavItemsStore = useCmsNavItemsStore()
    const slideOverStore = useSlideOverStore()
    const router = useRouter()

    return [
        {
            title: 'menu.home',
            path: '/',
            icon: 'heroicons:home-solid',
            showUnauthenticated: true,
            showAuthenticated: true,
        },
        ...(useRuntimeConfig()?.public?.underConstruction ? [] :
            [
                {
                    title: 'menu.fundingPrograms',
                    function: () => {
                        slideOverStore.setSlideOverOpen(true)
                        slideOverStore.setTitle('menu.fundingPrograms')
                        slideOverStore.setDescription('fundingPrograms.slideOver.description')
                        slideOverStore.setComponent('FundingProgramsSelection')
                        slideOverStore.setContext(null)
                    },
                    showUnauthenticated: true,
                    showAuthenticated: true,
                },
                {
                    title: 'menu.processes',
                    path: 'processes',
                    ability: ['viewAny', 'processes'],
                    children: [
                        {
                            title: 'menu.groupedByEvents',
                            function: () => {
                                localStorage.setItem('applicationArea-processes-activeTab', 'events')
                                router.push({path: '/processes/grouped-by-events'})
                            },
                            showUnauthenticated: false,
                            showAuthenticated: true,
                        },
                        {
                            title: 'menu.groupedByFundingProgram',
                            function: () => {
                                localStorage.setItem('applicationArea-processes-activeTab', 'fundingPrograms')
                                router.push({path: '/processes/grouped-by-funding-programs'})
                            },
                            showUnauthenticated: false,
                            showAuthenticated: true,
                        }
                    ],
                    showUnauthenticated: false,
                    showAuthenticated: true,
                },
                {
                    title: 'menu.statistics',
                    path: 'statistics',
                    ability: ['viewAny', 'statisticProcesses'],
                    showUnauthenticated: false,
                    showAuthenticated: true,

                },
                ...(useCmsNavItems) ? cmsNavItemsStore.cmsNavItems.filter((item) => item.showInHeaderMenu && !item.parent).map((item) => {
                    return {
                        titleRaw: item?.title,
                        path: item?.slug,
                        isCmsPath: true,
                        children: [
                            ...cmsNavItemsStore.cmsNavItems.filter((child) => child.parent?.id === item.id && child.showInHeaderMenu).map((child) => {
                                return {
                                    titleRaw: child?.title,
                                    path: child?.slug,
                                    isCmsPath: true,
                                    showUnauthenticated: true,
                                    showAuthenticated: true
                                }
                            })
                        ],
                        showUnauthenticated: true,
                        showAuthenticated: true
                    }
                }) : []
            ]
        ),
        {
            title: 'menu.login',
            function: () => {
                slideOverStore.setSlideOverOpen(true)
                slideOverStore.setTitle('menu.login')
                slideOverStore.setDescription('')
                slideOverStore.setComponent('AuthWrapper')
                slideOverStore.setContext(null)
            },
            showUnauthenticated: true,
            showAuthenticated: false,
        }
    ]
}